import { css } from '@emotion/react'
import { Cell, Flow, Grid, HeadingSection, InfoLabel, Text } from 'bold-ui'

export interface DadosResponsavelConselhoSectionProps {
  titulo: string
  dataLabel: string
  data: string
  responsavelTitulo: string
  nome: string
  cns: string
  conselhoTitulo?: string
  conselho: string
  numero: string
}

export function DadosResponsavelConselhoSection(props: Readonly<DadosResponsavelConselhoSectionProps>) {
  const { titulo, dataLabel, data, responsavelTitulo, nome, cns, conselhoTitulo = 'Conselho', conselho, numero } = props

  const { grid } = createStyles()

  return (
    <>
      <HeadingSection level={4} vSpace={2} title={titulo} />
      <Grid style={grid}>
        <Cell size={12}>
          <InfoLabel title={dataLabel}>{data}</InfoLabel>
        </Cell>
        <Grupo
          titulo={responsavelTitulo}
          itens={[
            { label: 'Nome:', value: nome },
            { label: 'CNS:', value: cns },
          ]}
        />
        <Grupo
          titulo={conselhoTitulo}
          itens={[
            { label: 'Nome:', value: conselho },
            { label: 'Número:', value: numero },
          ]}
        />
      </Grid>
    </>
  )
}

interface GrupoItem {
  label: string
  value: string
}

interface GrupoProps {
  titulo: string
  itens: GrupoItem[]
}

function Grupo(props: Readonly<GrupoProps>) {
  const { titulo, itens } = props

  return (
    <Cell size={6}>
      <Flow direction='vertical' gap={0}>
        <Text fontWeight='bold'>{titulo}</Text>
        {itens.map(({ label, value }) => (
          <Text key={label}>
            <Text fontWeight='bold'>{label}</Text>
            {` `}
            {value}
          </Text>
        ))}
      </Flow>
    </Cell>
  )
}

const createStyles = () => ({
  grid: css`
    width: 100%;
  `,
})
